// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1UYEy","buttons":"RemoveExpirationActionButtons_buttons__3RUKM"};